import { ParserSplitFunction } from '../mapReduceParser/types'

export const makePattern = (patterns: string[]): string => {
  return `(${patterns.join('|')})`
}

export const splitByRegExps = (input: string, patterns: string[]): string[] => {
  const pattern = makePattern(patterns)
  return input.split(new RegExp(pattern)).filter((part) => part)
}

export const makeSplit = (patterns: string[]): ParserSplitFunction => {
  return (input: string) => splitByRegExps(input, patterns)
}
